<template>
  <v-flex xs12 sm8 md6 class="main-col">
    <p class="gotham-m guide-title" transition="scale-transition">TRACK+</p>
    <p class="gotham-m guide-desc">{{ $t('t4') }}</p>
    <v-card class="lbt-card">
      <v-card-media>
        <img
          src="../images/trackplus/main.jpg"
          style="width:100%;height:100%;"
        >
      </v-card-media>
      <v-card-title primary-title class="card-content" :style="{ marginTop: 0 }">
        <ul id="menu">
          <li @click="$vuetify.goTo('#download')">
            {{ $t('t7') }}
          </li>
          <li @click="$vuetify.goTo('#interface')">
            {{ $t('t8') }}
          </li>
          <li @click="$vuetify.goTo('#bluetooth')">
            {{ $t('t9') }}
          </li>
          <li @click="$vuetify.goTo('#operation')">
            {{ $t('t10') }}
          </li>
          <li @click="$vuetify.goTo('#status')">
            {{ $t('t11') }}
          </li>
          <li @click="$vuetify.goTo('#citymix')">
            {{ $t('t12') }}
          </li>
          <li @click="$vuetify.goTo('#plus1')">
            {{ $t('t13') }}
          </li>
          <li @click="$vuetify.goTo('#faq')">
            {{ $t('t14') }}
          </li>
          <li @click="$vuetify.goTo('#spec')">
            {{ $t('t15') }}
          </li>
        </ul>
      </v-card-title>
    </v-card>
    <v-card id="download" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t16' )}}</p>
        <p class="lbt-content">{{ $t('t17') }}</p>
        <v-layout row justify-center align-center>
          <v-flex xs8>
            <v-layout column align-center>
              <img class="qr-pic" src="../images/qr_download.png">
              <v-btn class="lbt-button" href="http://download.birdytone.com.cn/index.html">Download</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-card id="interface" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t20' )}}</p>
        <img src="../images/trackplus/content_trackplus01.png" width="100%" />
        <p class="lbt-content-light">{{ $t('t21') }}</p>
      </v-card-title>
    </v-card>
    <v-card id="bluetooth" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t22' )}}</p>
        <p class="lbt-content-dark">{{ $t('t23') }}</p>
        <p class="lbt-content">{{ $t('t24') }}</p>
        <img src="../images/trackplus/content_trackplus02.png" width="100%" />
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t25') }}</p>
        <p class="lbt-content">{{ $t('t26') }}</p>
        <p class="lbt-content-light">{{ $t('t27') }}</p>
        <img src="../images/trackplus/content_trackplus03.png" width="100%" />
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t28') }}</p>
        <p class="lbt-content">{{ $t('t29') }}</p>
        <img src="../images/trackplus/content_trackplus04.png" width="100%" />
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t30') }}</p>
        <p class="lbt-content">{{ $t('t31') }}</p>
        <img src="../images/trackplus/content_trackplus05.png"
          width="100%"
          :style="{ marginBottom: '-20px' }" />
      </v-card-title>
    </v-card>
    <v-card id="operation" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t32' )}}</p>
        <img src="../images/trackplus/content_trackplus06.png" width="100%" />
        <p class="lbt-content-light">{{ $t('t33') }}</p>
        <p class="lbt-content-dark">{{ $t('t34') }}</p>
        <p class="lbt-content">{{ $t('t35') }}</p>
        <p class="lbt-content">{{ $t('t36') }}</p>
        <p class="lbt-content">{{ $t('t37') }}</p>
        <p class="lbt-content">{{ $t('t38') }}</p>
        <div class="hairline"></div>
        <img src="../images/trackplus/content_trackplus07.png" width="100%" />
        <p class="lbt-content-light">{{ $t('t39') }}</p>
        <p class="lbt-content-dark">{{ $t('t40') }}</p>
        <p class="lbt-content">{{ $t('t41') }}</p>
        <p class="lbt-content">{{ $t('t42') }}</p>
        <p class="lbt-content">{{ $t('t43') }}</p>
        <p class="lbt-content">{{ $t('t44') }}</p>
        <p class="lbt-content-light">{{ $t('t45') }}</p>
      </v-card-title>
    </v-card>
    <v-card id="status" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t46' )}}</p>
        <img src="../images/trackplus/content_trackplus07a.png" width="100%" />
        <p class="lbt-content-light">{{ $t('t47') }}</p>
        <p class="lbt-content-dark">{{ $t('t48') }}</p>
        <p class="lbt-content">{{ $t('t49') }}</p>
        <p class="lbt-content">{{ $t('t50') }}</p>
        <p class="lbt-content">{{ $t('t51') }}</p>
        <p class="lbt-content">{{ $t('t52') }}</p>
        <p class="lbt-content">{{ $t('t53') }}</p>
      </v-card-title>
    </v-card>
    <v-card id="citymix" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t54' )}}</p>
        <p class="lbt-content-dark">{{ $t('t55') }}</p>
        <p class="lbt-content">{{ $t('t56') }}</p>
        <img src="../images/trackplus/content_trackplus10.png" width="100%" />
      </v-card-title>
    </v-card>
    <v-card id="plus1" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t57' )}}</p>
        <p class="lbt-content-dark">{{ $t('t58') }}</p>
        <p class="lbt-content">{{ $t('t59') }}</p>
        <p class="lbt-content">{{ $t('t60') }}</p>
        <img src="../images/trackplus/content_trackplus08.png" width="100%" />
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t61') }}</p>
        <p class="lbt-content">{{ $t('t62') }}</p>
        <img src="../images/trackplus/content_trackplus09.png" width="100%" />
      </v-card-title>
    </v-card>
    <v-card id="faq" class="lbt-card">
      <v-card-title primary-title class="card-content">
        <p class="lbt-card-title">{{ $t('t63' )}}</p>
        <p class="lbt-content-dark">{{ $t('t64') }}</p>
        <p class="lbt-content">{{ $t('t65') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t66') }}</p>
        <p class="lbt-content">{{ $t('t67') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t68') }}</p>
        <p class="lbt-content">{{ $t('t69') }}</p>
        <div class="hairline"></div>
        <p class="lbt-content-dark">{{ $t('t70') }}</p>
        <p class="lbt-content">{{ $t('t71') }}</p>
        <p class="lbt-content-light">{{ $t('t72') }}</p>
      </v-card-title>
    </v-card>
    <v-card id="spec" class="lbt-card">
      <v-card-title primary-title class="card-content spec-card">
        <p class="lbt-card-title">{{ $t('t73' )}}</p>
        <p class="lbt-content-dark">{{ $t('t74') }}</p>
        <p class="lbt-content">Libratone TRACK+</p>
        <p class="lbt-content-dark">{{ $t('t76') }}</p>
        <p class="lbt-content">LTI600</p>
        <p class="lbt-content-dark">{{ $t('t78') }}</p>
        <p class="lbt-content">2*11.8mm</p>
        <p class="lbt-content-dark">{{ $t('t80') }}</p>
        <p class="lbt-content">105dB@1mW,1kHz</p>
        <p class="lbt-content-dark">{{ $t('t82') }}</p>
        <p class="lbt-content">20~20kHz</p>
        <p class="lbt-content-dark">{{ $t('t84') }}</p>
        <p class="lbt-content">{{ $t('t85') }}</p>
        <p class="lbt-content-dark">{{ $t('t86') }}</p>
        <p class="lbt-content">{{ $t('t87') }}</p>
        <p class="lbt-content-dark">{{ $t('t88') }}</p>
        <p class="lbt-content">{{ $t('t89') }}</p>
        <p class="lbt-content-dark">{{ $t('t90') }}</p>
        <p class="lbt-content">{{ $t('t91') }}</p>
        <p class="lbt-content-dark">{{ $t('t92') }}</p>
        <p class="lbt-content">28g</p>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Content'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/trackplus/content.vue